<template>
    <form-row title="Does Any Portion Go Towards Purchase Price?">
        <div class="flex-none sm:w-36 my-2">
            <div v-show="earnest_money_toward_purchase_by_percent">
                <input-money
                    :value="earnest_money_toward_purchase_by_percent"
                    tabindex="-1"
                    :read_only="true"
                />
            </div>

            <div v-show="! earnest_money_toward_purchase_by_percent">
                <input-money
                    v-model="earnest_money_toward_purchase_entered"
                    :read_only="read_only"
                />
            </div>

            <input
                name="earnest_money_toward_purchase_amount"
                type="hidden"
                :value="earnest_money_toward_purchase_amount"
                :read_only="true"
            />
        </div>

        <div class="flex flex-1 items-center my-2">
            <span class="text-sm text-gray-600 sm:pl-6 pr-6">
                {{ $t('- OR -') }}
            </span>

            <div class="w-1/4 sm:w-1/5">
                <input-percent
                    name="earnest_money_toward_purchase_percent"
                    v-model="earnest_money_toward_purchase_percent"
                    :read_only="read_only"
                />
            </div>

            <span class="text-sm text-gray-600 leading-snug pl-4">
                {{ $t('of') }} {{ total_earnest_money_formatted }} <br>{{ $t('total earnest money') }}
            </span>
        </div>
    </form-row>
</template>

<script>
import MoneyFunctions from '../../../../mixins/money-functions.js';

export default {
    mixins: [
        MoneyFunctions,
    ],

    props: {
        commercial: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            earnest_money_toward_purchase_percent:
                this.commercial.earnest_money_toward_purchase_percent,
            earnest_money_toward_purchase_entered:
                this.commercial.earnest_money_toward_purchase_amount,
        }
    },

    computed: {
        total_earnest_money() {
            return this.formatMoney(store.state.total_earnest_money);
        },
        earnest_money_toward_purchase_by_percent() {
            return this.earnest_money_toward_purchase_percent
                ? this.formatMoney((this.earnest_money_toward_purchase_percent / 100) * this.moneyVal(this.total_earnest_money))
                : null;
        },
        earnest_money_toward_purchase_amount() {
            return this.earnest_money_toward_purchase_by_percent || this.earnest_money_toward_purchase_entered;
        },
        total_earnest_money_formatted() {
            return this.total_earnest_money && ! isNaN(this.total_earnest_money)
                ? '$' + this.formatMoneyToString(this.total_earnest_money)
                : '';
        },
    },
}
</script>
